module.exports = {"340522100":"环峰镇","340522101":"运漕镇","340522102":"铜闸镇","340522103":"陶厂镇","340522104":"林头镇","340522105":"清溪镇","340522106":"仙踪镇","340522107":"昭关镇","340522400":"安徽含山工业园区","340522401":"安徽含山经济开发区","340522402":"含山县褒禅山经济园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340522.json
// module id = 1077
// module chunks = 0